import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import { SgdsMasthead } from "@govtechsg/sgds-masthead-react";

import Navbar from "../../Components/NavbarComponent";
import FooterComponent from "../../Components/FooterComponent";
import SideNavComponent from "../../Components/SideNavComponent";
import MastheadAnnouncement from '../../Components/MastheadAnnouncement'

import Endpoint from "../../Components/Endpoint";
import endpointsData from "../../json/sampleEndpts.json";

const ReverseGeocodeServices = () => {
  const location = useLocation();

  const endpointreturn = (id) => {

    let endpt_elem = endpointsData;
    endpt_elem = endpt_elem.find((item) => item.page_section === id);

    const pythonCode = `import requests
    \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
    \nheaders = {"Authorization": "**********************"}
    \nresponse = requests.get(url, headers=headers)
    \nprint(response.text)`;

    const jsCode = `const url = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}";
const authToken = '**********************';  // Replace with your access token

fetch(url, {
  method: '${endpt_elem.method}',
  headers: {
    'Authorization': \`\${authToken}\`,  // API token for authorization
  }
})
.then(response => response.json())  // Parse response as JSON
.then(data => console.log(data))     // Log the data to the console
.catch(error => console.error('Error:', error));  // Log any errors`;

    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const { state } = location;
  const [activeKey, setActiveKey] = useState("");
  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };
  useEffect(() => {
    if (state === null) {
      clickButton("0");
    } else {
      clickButton(location.state.toString());
    }
  }, [state]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>

      <Helmet>
        <title>Reverse Geocode API: Retrieve Address Information by Coordinates | OneMap API</title>
        <meta
          name="description"
          content="Use OneMap's Reverse Geocode API to retrieve addresses within a specified radius of a location using WGS84 or SVY21 coordinates. Set custom buffers for building or road searches, and receive additional features like playgrounds and reservoirs. Ideal for location-based services"
        />
      </Helmet>
      <MastheadAnnouncement/>
      <Navbar />
      <div className="row qx-0 mb-5 position-relative">
        <div className="col-1 d-md-none d-inline">
          <div
            className="btn btn-primary d-md-none position-fixed sideBarBtn"
            onClick={(e) => {
              handleCollapse();
              if (isCollapsed) {
                window.scrollTo(0, 0);
              }
            }}
          >
            Show Side Bar
          </div>
        </div>

        <div
          className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? "collapse" : ""
          }`}
        >
          <SideNavComponent />
        </div>

        <div className="col-12 col-md-9 qx-0 px-3">
          <>
            <div id="reverseGeocode" className="om-reverseGeocode-section">
              <h1>Reverse Geocode</h1>
              <div className="om-reverseGeocode-intro">
                {/* <p>
                  Use Reverse Geocode when you have a location (X/Y) and need a corresponding address or road name for that
                  location. It can be used to show the location details of tracked assets.
                </p> */}
                <p>
                  The API retrieves an address that lies within a specified
                  buffer/radius of a specified location (in latitude/longitude
                  under WGS84 coordinates or Y/X under SVY21 coordinates).
                </p>
                <p>
                  The maximum buffer/radius is 500m for buildings and 20m for
                  roads. Fields without value will return as "NIL". Building
                  name will return "null", if the building is not named. Longer
                  response time is expected for searching of some addresses. By
                  default, the system will return a maximum of 10 nearest
                  buildings.
                </p>
                <p>Reverse Geocode is available in SVY21 and WGS84 format.</p>
              </div>
              <h4 id="svy21">Reverse Geocode (SVY21)</h4>
              <h3 className="om-reverseGeocode-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <p>
                400 - Please send the access token in the request header as a
                bearer token.
              </p>
              <p>400 - Your provided location is empty.</p>
              <p>400 - Your provided location is invalid.</p>
              <p>
                401 - Token has expired: Session expired. Please refresh your
                token (if still within refresh window) or re-login.
              </p>
              <p>
                401 - Invalid token: Could not decode token: The token xxx; is
                an invalid JWS.
              </p>
              <p>
                403 - Access Forbidden. GET access to component 'xxx' of service
                'xxx' is not allowed by this user's role.
              </p>
              <p>429 - API limit(s) exceeded.</p>
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">QUERY PARAMETERS</h4>
                </div>

                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      location
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>X and Y coordinates in SVY21 format.</p>
                    </div>
                  </div>
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      buffer
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>
                        Optional. Values: 0-500 (in meters). Rounds up all
                        buildings in a circumference from a point and search
                        building add
                      </p>
                    </div>
                  </div>
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      addressType
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>
                        Optional. Values: HDB or All. Allows users to define
                        property types within the buffer/radius. If HDB is
                        selected, result
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("revgeocodexy")} />
              <h4 id="wgs84">Reverse Geocode (WGS84)</h4>
            </div>
            <h3 className="om-reverseGeocode-err">
              <strong className="slate-bold">Possible Error Responses</strong>
            </h3>
            <p>
              400 - Please send the access token in the request header as a
              bearer token.
            </p>
            <p>400 - Your provided location is empty.</p>
            <p>400 - Your provided location is invalid.</p>
            <p>
              401 - Token has expired: Session expired. Please refresh your
              token (if still within refresh window) or re-login.
            </p>
            <p>
              401 - Invalid token: Could not decode token: The token xxx; is an
              invalid JWS.
            </p>
            <p>
              403 - Access Forbidden. GET access to component 'xxx' of service
              'xxx' is not allowed by this user's role.
            </p>
            <p>429 - API limit(s) exceeded.</p>
            <div className="om-reverseGeocode-wrapper">
              <div className="om-reverseGeocode">
                <h4 className="om-reverseGeocode-header">HEADER PARAMETERS</h4>
              </div>
              <div className="om-reverseGeocode-items">
                <div className="om-reverseGeocode-item">
                  <div className="label-method">
                    Authorization
                    <span className="label-type">string</span>
                    <span className="label-required">Required</span>
                  </div>
                  <div className="om-reverseGeocode-desc">
                    <p>API token provided by the Authentication Service.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="om-reverseGeocode-wrapper">
              <div className="om-reverseGeocode">
                <h4 className="om-reverseGeocode-header">QUERY PARAMETERS</h4>
                {/* <div className='om-reverseGeocode-expand-button'>Expand All</div> */}
              </div>
              <div className="om-reverseGeocode-items">
                <div className="om-reverseGeocode-item">
                  <div className="label-method">
                    location
                    <span className="label-type">string</span>
                  </div>
                  <div className="om-reverseGeocode-desc">
                    <p>
                    Latitude and longitude coordinates in WGS84 format.
                    </p>
                  </div>
                </div>
                <div className="om-reverseGeocode-item">
                  <div className="label-method">
                    buffer
                    <span className="label-type">string</span>
                  </div>
                  <div className="om-reverseGeocode-desc">
                    <p>
                      Optional. Values: 0-500 (in meters). Rounds up all
                      buildings in a circumference from a point and search
                      building add
                    </p>
                  </div>
                </div>
                <div className="om-reverseGeocode-item">
                  <div className="label-method">
                    addressType
                    <span className="label-type">string</span>
                  </div>
                  <div className="om-reverseGeocode-desc">
                    <p>
                      Optional. Values: HDB or All. Allows users to define
                      property types within the buffer/radius. If HDB is
                      selected, result
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <Endpoint {...endpointreturn("revgeocode")} />
          </>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};
export default ReverseGeocodeServices;
